import * as React from 'react'

export default function Icon({ name, text = '' }) {
    return (
        <i className={`icon-${name}`}>
            <span className="blind">{text}</span>
        </i>
    )
}
